export enum PlanPermittedAction {
  READ = 'read',
  WRITE = 'write',
  DELETE = 'delete',
  PERMISSIONS = 'permissions',
  CONNECT_SCHEDULE = 'connect_schedule',
  DELETE_TASK = 'delete_task',
  CONNECT_TASKS = 'connect_tasks',
  PLAN_ASSIGN_ALL = 'plan_assign_all',
  DISCONNECT_FROM_SCHEDULE = 'disconnect_from_schedule',
}
